import {
    UNIONLISTAGENTFORPARTNER_SUCCESS,
    UNIONLISTAGENTFORPARTNER_FAILED,
    RESET_UNIONLISTAGENTFORPARTNER,
    LOADING_UNIONLISTAGENTFORPARTNER,
    NETWORK_ERROR_UNIONLISTAGENTFORPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_UNIONLISTAGENTFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case UNIONLISTAGENTFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case UNIONLISTAGENTFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_UNIONLISTAGENTFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_UNIONLISTAGENTFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};